import { css } from '@emotion/react'
import type { ProductDescription } from '@src/type/product'
import { IMG_STORAGE_URL } from '@src/utils/constants'

type PropsType = {
	descriptions?: ProductDescription[]
}
const ProductDescriptions = ({ descriptions }: PropsType) => {
	return (
		<div>
			{descriptions && (
				<div>
					{descriptions.map((description, index) => {
						return (
							<div key={`product-description-index-${JSON.stringify(description)}`}>
								{description?.filename && (
									<img
										css={css`
											max-width: 50rem;
										`}
										src={`${IMG_STORAGE_URL}/commerce/product/description_img/${description.filename}`}
										alt={`${index}번째 상품 설명`}
									/>
								)}
							</div>
						)
					})}
				</div>
			)}
		</div>
	)
}
export default ProductDescriptions
